const global = window

inputs.alias.list = 'select'

// inputs.typesDelay.select = 2

inputs.fn.select = {
    language: {
        errorLoading: () => __("Les résultats ne peuvent pas être chargés."),
        inputTooLong: (args) => {
        const n = args.input.length - args.maximum;
        return __("Supprimez %s caractère(s)", n);
        },
        inputTooShort: (args) => {
        const n = args.minimum - args.input.length;
        return __("Saisissez au moins %s caractère(s)", n);
        },
        loadingMore: () => __("Chargement de résultats supplémentaires…"),
        maximumSelected: (args) => {
        return __("Vous pouvez seulement sélectionner %s élément(s)", args.maximum);
        },
        noResults: () => __("Aucun résultat trouvé"),
        searching: () => __("Recherche en cours…"),
        removeAllItems: () => __("Supprimer tous les éléments"),
        removeItem: () => __("Supprimer l'élément"),
        // Le correctif pour éviter le crash "searchLabel is not a function"
        search: () => __("Rechercher")
    },
    clear(input, data) {
        if (input.val()) data.oldValue = input.val()
        input.empty().select2({
            language: inputs.fn.select.language,
            data: [],
        })
    },
    update(input, data, inputData, response) {
        const options = response.data;
        let newOptions = [];
        let newOption = null;

        if (!data.mandatory) {
            newOptions.push({
                text: '',
                id: '',
                img: '',
                group: '',
            });
        }

        let fieldId = 'value,id'
        let fieldLabel = 'label,name,title'
        let fieldImg = 'icon,ico,img'
        let fieldGroup = 'group'

        if (data.model && data.model.field) {
            if (data.model.field.id) fieldId = data.model.field.id
            if (data.model.field.label) {
                fieldLabel = data.model.field.label
            }
            if (data.model.field.img) fieldImg = data.model.field.img
        }

        fieldId = fieldId.split(',')
        fieldLabel = fieldLabel.split(',')
        fieldImg = fieldImg.split(',')
        fieldGroup = fieldGroup.split(',')

        $.each(options, function (key, value) {
            const entry = this
            let text
            let id
            let img
            let group

            if (!isAssociativeArray(entry)) {
                id = entry[0]
                text = entry[1]
                img = entry[2]
                group = entry[3]
            } else if (typeof entry == 'object') {
                $.each(fieldLabel, function () {
                    text = entry[this]
                    if (text) return false
                })

                $.each(fieldId, function () {
                    id = entry[this]
                    if (id) return false
                })

                $.each(fieldImg, function () {
                    img = entry[this]
                    if (img) return false
                })

                $.each(fieldGroup, function () {
                    group = entry[this]
                    if (group) return false
                })
            }

            if (group) {
                // Vérifier si le groupe existe déjà
                const existingGroup = newOptions.find((option) => option.text === group)

                if (existingGroup) {
                    // Ajouter l'élément au groupe existant
                    existingGroup.children.push({
                        id,
                        text,
                        img,
                    })
                } else {
                    newOption = {
                        text: group,
                        children: [
                            {
                                id,
                                text,
                                img,
                            },
                        ],
                    }
                    newOptions.push(newOption)
                }
            } else {
                newOption = {
                    id,
                    text,
                    img,
                }
                newOptions.push(newOption)
            }
        });

        const select2Options = data.properties || {
            language: inputs.fn.select.language,
            minimumResultsForSearch: 20,
            dropdownCssClass: 'select--list bigdrop',
            templateResult: selectBasicIconFormat,
            templateSelection: selectBasicIconFormat,
            escapeMarkup: (m) => m,
        };
        select2Options.data = newOptions

        global.noQ = true

        input.empty().select2(select2Options)
        input.val(data.oldValue).trigger('change')

        if (data.free && input.val() != data.oldValue) {
            input.append(new Option(data.oldValue, data.oldValue, true, true)).trigger('change');
        }

        global.noQ = false
    },
    init(data, name, niceName, type, input, parent, inputWindow) {
        if (!input || input.hasClass('done')) return false
        input.addClass('done')

        let tpl = (data.type === 'thumb') ? selectBasicThumbFormat : selectBasicIconFormat
        let dropdownClass = (data.type === 'thumb') ? 'select--thumb' : 'select--list bigdrop'
        let minResults = (data.type === 'thumb') ? 40 : 20

        const properties = {
            minimumResultsForSearch: minResults,
            dropdownCssClass: dropdownClass,
            templateResult: tpl,
            templateSelection: selectBasicIconFormat,
            language: inputs.fn.select.language,
            escapeMarkup(m) {
                return m
            },
        }
        const enableSort = false

        input.on('select2:open', inputs.fn.select.onOpen)

        // remote
        if (data && data.remote) {
            properties.ajax = {
                url: data.remote,
                dataType: 'json',
                processResults(data) {
                    data = data.data
                    const reformatedArray = []

                    for (let i = 0; i < data.length; i++) {
                        const innerArray = data[i]
                        const obj = {
                            id: innerArray[0],
                            text: innerArray[1],
                            img: innerArray[2],
                        }
                        reformatedArray.push(obj)
                    }
                    return {
                        results: reformatedArray,
                    }
                },
            }
            properties.minimumResultsForSearch = 0
        }

        // tags
        if (data && data.tags) {
            properties.tags = data.tags
            properties.createTag = function (params) {
                var term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                return {
                    id: term,
                    text: term,
                    img: term,
                }
            }
        }

        // multiple
        if (data && data.multi) {
            properties.multiple = data.multi
        }
        if (data && data.max) {
            properties.maximumSelectionLength = data.max
        }

        // free
        if (data && data.free) {
            properties.tags = true
            properties.minimumResultsForSearch = 0
            properties.createTag = function (params) {
                var term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                return {
                    id: term,
                    text: term,
                    img: term,
                }
            }
        }

        // Matcher
        properties.matcher = inputs.fn.search.select2Matcher

        // Init Select2
        data.properties = properties;
        input.select2(properties).on('select2-open', function (e) {
            $('.select-result-label').click(function () {
                if ($(this).hasClass('active')) {
                    const others = $('.select-result-sub')
                    others.slideUp()
                    $('.select-result-label').removeClass('active')
                } else {
                    const current = $(this).next()
                    const others = $('.select-result-sub').not(current)
                    others.slideUp()
                    current.slideDown()
                    $('.select-result-label').removeClass('active')
                    $(this).addClass('active')
                }
            })
        })

        input.on('focus', function () {
            $(this).next('.select2-container').find('.select2-selection').trigger('focus');
            $('.select2-search__field').trigger('focus');
        });

        // Multiples Drag and Drop
        if (enableSort) {
            input.on('change', function () {
                $(this).html(input.val())
            })
            input
                .select2('container')
                .find('ul.select-choices')
                .sortable({
                    containment: 'parent',
                    start() {
                        input.select2('onSortStart')
                    },
                    update() {
                        input.select2('onSortEnd')
                    },
                })
        }

        // transpose classe
        if (typeof data !== 'undefined') {
            input.next().addClass(data.class)
        }
    },
    onOpen(e) {
        if (!$(this).data('data').multiple && !$(this).data('data').tags) {
            // 1. On cherche le conteneur de la liste (qui n'existe peut-être pas encore)
            // On utilise un court délai pour laisser Select2 créer le DOM du dropdown
            setTimeout(() => {
                const $results = $('.select2-results__options');

                // 2. On désactive TOUTE interaction souris sur la liste
                $results.css('pointer-events', 'none');

                // 3. On attend le mouseup global
                $(window).one('mouseup.select2Lock', function() {
                    // 4. On réactive la liste après un micro-délai pour être sûr
                    // que le mouseup n'est plus en train d'être propagé
                    setTimeout(() => {
                        $results.css('pointer-events', 'auto');
                    }, 50);
                });
            }, 0);
        }

        // imgToSvg($('.select2-results__options'));

        const dropdownSelect = $(
            '.select2-dropdown > .select2-results > .select2-results__options',
        )
        if (dropdownSelect.length) {
            const isAbove = $('.select2-dropdown').hasClass('select2-dropdown--above');
            if (!isAbove) {
                dropdownSelect.css('maxHeight', '700px')
                const maxHeight = $(window).scrollTop()
                    + $(window).height()
                    - (dropdownSelect ? dropdownSelect.offset().top : 0)
                if (maxHeight < dropdownSelect.height()) {
                    dropdownSelect.css('maxHeight', maxHeight)
                }
            }

            /*
            if (dropdownSelect.offset().top < $(window).scrollTop()) {
                $('.select2-container--open').css(
                    'top',
                    $(window).scrollTop(),
                )
            }
            */

            /*
            if (data.layout == 'thumb') {
                const dropdownSelect = $('.select2-dropdown')
                dropdownSelect.css('minWidth', '50vw')
                const maxWidth = $(window).width() - dropdownSelect.offset().left
                if (maxWidth < dropdownSelect.width()) {
                    dropdownSelect.css('minWidth', maxWidth)
                }
            }
            */
        }

        dropdownSelect.css('pointer-events', 'none');
        setTimeout(() => {
            dropdownSelect.css('pointer-events', 'all');
        }, 200);
    },
}

inputs.types.select = function (data, name, niceName, type, input, parent, inputWindow) {
    setTimeout(function() {
        inputs.fn.select.init(data, name, niceName, type, input, parent, inputWindow)
    }, 10)
    data.oldValue = data.value
    data.clear = function () { inputs.fn.select.clear(input, data) }
    data.update = function (inputData, response) { inputs.fn.select.update(input, data, inputData, response) }
    return data
}

global.selectBasicIconFormat = function (state) {
    if (!state) return '';
    let data = {}
    if (state.element) data = $(state.element.closest('select')).data('data');
    let currentBackgroundImage = '';

    if (state.img) {
        currentBackgroundImage = state.img;
    } else if (state.element) {
        currentBackgroundImage = $(state.element).data('img');
        if (!currentBackgroundImage) {
            currentBackgroundImage = $(state.element).css('background-image');
            currentBackgroundImage = /^url\((['"]?)(.*)\1\)$/.exec(
                currentBackgroundImage,
            );
            currentBackgroundImage = currentBackgroundImage
                ? currentBackgroundImage[2]
                : ''; // Si correspond, récupère l'URL, sinon ""
        }
        if (!currentBackgroundImage) {
            currentBackgroundImage = state.element.dataset.img;
        }
    }

    const text = (state.text != null && typeof state.text !== 'undefined') ? String(state.text) : '';
    const textHtml = text ? text.split(' ').join('</span><span class="select-txt"> ') : '';

    if (!currentBackgroundImage) {
        return (
            '<span class="select-ico"> </span><span class="select-txt"> '
            + textHtml
            + '</span>'
        )
    } // optgroup

    return (
        iconImg(currentBackgroundImage, 'select-ico', '', 'contain', (data && data.size) ? data.size : 24)
        + '<span class="select-txt"> '
        + textHtml
        + '</span>'
    );
}

global.selectBasicThumbFormat = function (state) {
    if (!state) return '';
    let currentBackgroundImage = ''
    if (state.element) {
        currentBackgroundImage = $(state.element).data('img')
        if (!currentBackgroundImage) {
            currentBackgroundImage = $(state.element).css('background-image');
            currentBackgroundImage = /^url\((['"]?)(.*)\1\)$/.exec(
                currentBackgroundImage,
            )
            currentBackgroundImage = currentBackgroundImage
                ? currentBackgroundImage[2]
                : ''; // Si la correspondance est trouvée, récupérez l'URL, sinon ""
        }
    }
    if (!currentBackgroundImage) currentBackgroundImage = 'status-help.png';
    const text = (state.text != null && typeof state.text !== 'undefined') ? String(state.text) : '';
    const returnAdd = ''; // Déclarez et initialisez la variable 'returnAdd' correctement

    return (
        returnAdd
        + "<div class='select2-results__option__el'><div class='select2-results__option__el__icon'>"
        + iconImg(
            currentBackgroundImage,
            'select2-results__option__el__icon_img',
        )
        + '</div><span class="select2-results__option__el__label">'
        + text
        + '</span></div>'
    )
}

/*
$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus()
})
*/

$.fn.select2.amd.require(['select2/dropdown/attachBody'], function (AttachBody) {
    const originalPosition = AttachBody.prototype._positionDropdown;

    AttachBody.prototype._positionDropdown = function () {
        // Appeler la méthode originale pour positionner le dropdown
        originalPosition.call(this);

        // Récupérer l'élément dropdown et ses dimensions
        const $dropdown = this.$dropdown;
        const $container = this.$container; // Parent du dropdown

        if ($dropdown.hasClass('select--thumb')) {
            let totalWidth = 0;

            if ($dropdown.data('originalWidth')) {
                $dropdown.css({
                    'minWidth': $dropdown.data('originalWidth'),
                });
            }

            $dropdown.find('.select2-results__options > li').each(function () {
                totalWidth += $(this).outerWidth(true); // Inclut la largeur, les marges si true
            });

            if (totalWidth && totalWidth < $dropdown.width()) {
                $dropdown.data('originalWidth', $dropdown.css('minWidth'))
                $dropdown.css({
                    'minWidth': totalWidth + 'px',
                });
            }
        }

        const parentRect = $container[0].getBoundingClientRect(); // Dimensions du parent
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        const spaceBelow = viewportHeight - parentRect.bottom;
        const spaceAbove = parentRect.top;

        const $results = $dropdown.find('.select2-results__options');
        $results.css('maxHeight', '700px'); // Réinitialiser pour mesurer la taille naturelle

        let dropdownRect = $dropdown[0].getBoundingClientRect();
        const nonResultsHeight = dropdownRect.height - ($results.outerHeight(true) || 0);

        let isAbove = false;
        if (spaceBelow < 300 && spaceAbove > spaceBelow) {
            isAbove = true;
        } else if (parentRect.bottom + dropdownRect.height > viewportHeight) {
            if (spaceAbove > spaceBelow) {
                isAbove = true;
            }
        }

        if (isAbove) {
            const allowedHeight = Math.max(100, spaceAbove - nonResultsHeight - 15);
            $results.css('maxHeight', allowedHeight + 'px');
            $dropdown.removeClass('select2-dropdown--below').addClass('select2-dropdown--above');
            $container.removeClass('select2-container--below').addClass('select2-container--above');
        } else {
            const allowedHeight = Math.max(100, spaceBelow - nonResultsHeight - 15);
            $results.css('maxHeight', allowedHeight + 'px');
            $dropdown.removeClass('select2-dropdown--above').addClass('select2-dropdown--below');
            $container.removeClass('select2-container--above').addClass('select2-container--below');
        }

        // Ré-obtenir les dimensions après ajustement du maxHeight
        dropdownRect = $dropdown[0].getBoundingClientRect();

        // Calculer les nouvelles positions si nécessaire
        let newLeft = parentRect.left;
        let newTop = isAbove ? (parentRect.top - dropdownRect.height) : parentRect.bottom;

        // Vérifier les débordements horizontaux
        if (parentRect.left + dropdownRect.width > viewportWidth) {
            newLeft = viewportWidth - dropdownRect.width;
        }

        // Appliquer les nouvelles positions si elles sont différentes
        if (newLeft !== dropdownRect.left || newTop !== dropdownRect.top) {
            $dropdown.css({
                position: 'fixed',
                left: Math.max(newLeft, 0) + 'px',
                top: Math.max(newTop, 0) + 'px',
            });
        }

        // Débogage
        console.debug('Dropdown repositionné :', {
            originalLeft: dropdownRect.left,
            originalTop: dropdownRect.top,
            adjustedLeft: newLeft,
            adjustedTop: newTop,
            dropdownWidth: dropdownRect.width,
            dropdownHeight: dropdownRect.height,
            viewportHeight: viewportHeight,
            viewportWidth: viewportWidth
        });
    };
});

/*
// Utiliser la méthode $.fn.select2.amd.require pour accéder au module de navigation du clavier
$.fn.select2.amd.require(['select2/selection/search', 'select2/results', 'select2/dropdown'], function (Search, Results, Dropdown) {

    // Sauvegarder les fonctions originales
    var originalSearch = Search.prototype.bind;
    var originalResults = Results.prototype.bind;
    var originalDropdown = Dropdown.prototype.bind;

    // Modifier le comportement des keybinds sur le champ de recherche
    Search.prototype.bind = function (container, $element) {
        originalSearch.call(this, container, $element);

        // Ajouter ou personnaliser les raccourcis clavier ici
        this.$search.on('keydown', function (evt) {
            if (evt.keyCode === 13) { // 13 = Entrée
                // Custom action: empêcher l'action par défaut (par exemple, ne pas soumettre)
                evt.preventDefault();
                console.log('Raccourci personnalisé: Entrée');
            }
        });
    };

    // Modifier le comportement des keybinds sur les résultats
    Results.prototype.bind = function (container, $element) {
        originalResults.call(this, container, $element);

        // Ajouter ou personnaliser les raccourcis clavier ici
        this.$results.on('keydown', function (evt) {
            if (evt.keyCode === 38) { // 38 = Flèche haut
                // Custom action: empêcher l'action par défaut
                evt.preventDefault();
                console.log('Raccourci personnalisé: Flèche haut');
            }
        });
    };

    // Modifier le comportement des keybinds sur le dropdown
    Dropdown.prototype.bind = function (container, $element) {
        originalDropdown.call(this, container, $element);

        // Ajouter ou personnaliser les raccourcis clavier ici
        this.$dropdown.on('keydown', function (evt) {
            if (evt.keyCode === 40) { // 40 = Flèche bas
                // Custom action: empêcher l'action par défaut
                evt.preventDefault();
                console.log('Raccourci personnalisé: Flèche bas');
            }
        });
    };
});
*/